var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTech(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 48.579,
    height: 56.676,
    viewBox: "0 0 48.579 56.676",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "noun-instruction-book-3611470",
    d: "M57.2,7.192A1.71,1.71,0,0,0,55.491,8.9l.017,42.505a3.25,3.25,0,0,1-3.246,3.252H16.81a3.1,3.1,0,0,1-2.971-2.227,2.938,2.938,0,0,1-.121-.937,3.1,3.1,0,0,1,2.265-2.9,2.953,2.953,0,0,1,.887-.127H48.519a4.343,4.343,0,0,0,4.112-2.954,4.258,4.258,0,0,0,.226-1.383L52.862,4.69a3.311,3.311,0,0,0-3.312-3.312h-35.8A3.312,3.312,0,0,0,10.439,4.69V50.337a6.49,6.49,0,0,0,6.371,7.716H52.261A6.653,6.653,0,0,0,58.842,52.3a6.809,6.809,0,0,0,.061-.893V8.895a1.708,1.708,0,0,0-1.7-1.7ZM26.676,10.141l.176-.1v8.967l1.731,1.2h6.129l1.736-1.2V10.041l.176.1a10.54,10.54,0,0,1-1.736,19.324c.005.127.011.237.011.342v9.783H27.53V29.806a3.864,3.864,0,0,1,.061-.65,10.536,10.536,0,0,1-.915-19.015Z",
    transform: "translate(-10.323 -1.377)"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTech);
export default __webpack_public_path__ + "static/media/tech.4f5b309ede5587f6b6f4766e86d0c130.svg";
export { ForwardRef as ReactComponent };